module.exports = __webpack_public_path__ + "img/style_0_8.b40cfba2.png";